/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Import_Media_TitleInputs */

const en_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Media File`)
};

const fr_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer un Fichier Média`)
};

const de_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediendatei importieren`)
};

const it_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa file multimediale`)
};

const ru_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайла`)
};

const es_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar archivo multimedia`)
};

const zh_cn2_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入媒体文件`)
};

const ja_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルのインポート`)
};

const hi_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया फ़ाइल आयात करें`)
};

const pt_pt2_toolbar_secondary_import_media_title = /** @type {(inputs: Toolbar_Secondary_Import_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar arquivo de mídia`)
};

/**
* | output |
* | --- |
* | "Import Media File" |
*
* @param {Toolbar_Secondary_Import_Media_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_import_media_title = /** @type {((inputs?: Toolbar_Secondary_Import_Media_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Import_Media_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_import_media_title(inputs)
	if (locale === "de") return de_toolbar_secondary_import_media_title(inputs)
	if (locale === "it") return it_toolbar_secondary_import_media_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_import_media_title(inputs)
	if (locale === "es") return es_toolbar_secondary_import_media_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_import_media_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_import_media_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_import_media_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_import_media_title(inputs)
	return en_toolbar_secondary_import_media_title(inputs)
});